module.exports = __webpack_public_path__ + "static/media/MP-SPEC-LQ104V1DG81.021d76db.pdf";